<template>
    <div>
        <header v-if="!isPreLoad" class="p-3">
            <div class="flex-titular">
                <div>
                    <h1 v-cloak>{{ translator.manteniment }}</h1>
                </div>
                <div></div>
            </div>
        </header>

        <div class="pc service">

            <!-- Spiner -->
            <div v-if="isPreLoad" style="height: 90vh; display:flex; justify-content:center; align-items:center;">
                <div class="hollow-dots-spinner">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
            <!-- Fin spiner -->

            <div v-if="!isPreLoad" class="container p-0">

                <div class="d-flex ml-auto wrap form-group pt-2" style="max-width: 200px; margin-bottom: 20px;">
                    <input type="text" id="buscador" v-model="searchQuery" class="form-control"
                        :placeholder="`${translator.buscar}...`" />

                    <!-- <label for="order" style="min-width: 100px;">
                        {{ translator.ordenarper }}
                    </label>
                    <select class="form-control" id="order" v-model="selectedOrder">
                        <option value="date asc">{{ translator.data }} ▲</option>
                        <option value="date desc">{{ translator.data }} ▼</option>
                        <option value="property asc">{{ translator.propietat }} ▲
                        </option>
                        <option value="property desc">{{ translator.propietat }} ▼
                        </option>
                    </select> -->
                </div>

                <table class="table table-striped tabla-incidencias" style="font-size: 14px;">
                    <thead>
                        <tr>
                            <th scope="col">{{ translator.data }}/{{ translator.propietat | toLower }}</th>
                            <th scope="col">{{ translator.incidencia }}</th>
                        </tr>
                    </thead>
                    <tbody v-cloak>
                        <router-link
                            :to="{ name: 'ServiceDetail', params: { service: service.service_id }, query: { id: $route.query.id } }"
                            v-for="(service, index) in orderedServices" :key="index" custom v-slot="{ navigate }"
                            class="ServiceDetail">
                            <tr @click="navigate" role="link">
                                <td>
                                    {{ service.service_date | transformDate }}
                                    <br>
                                    {{ service.lodging_name }}

                                    <!-- es Edificio -->
                                    <!-- <span v-if="service.lodging_type == 'building'"><i
                                            class="fa-light fa-building"></i></span> -->
                                </td>
                                <td style="vertical-align:inherit;">
                                    <div style="display:flex; justify-content:space-between; align-items:center;">

                                        <span style="display: flex">
                                            <span v-if="service.service_priority != ''"
                                                class="badge badge-danger posicion-baget"
                                                style="width: 55px; display: flex; justify-content: center; align-items: center;">
                                                {{ service.service_priority }}
                                            </span>
                                            <span v-else style="width: 55px;"></span>
                                            <!-- es Edificio -->
                                            <!-- <span v-if="service?.lodging_zone !== ''"
                                                style="margin-left: 8px; font-weight: 500;">
                                                {{ service.lodging_zone }}:
                                            </span> -->
                                            <span style="margin-left: 8px;">
                                                {{ service.service_headline }}
                                            </span>
                                        </span>
                                        <div>
                                            <i class="fal fa-chevron-right" style="line-height: inherit;"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </router-link>
                    </tbody>
                </table>
            </div>

            <NavbarService :translator="translator" :user="user" />
        </div>
    </div>
</template>

<script>
import NavbarService from '@/components/NavbarService.vue';
import { mapState } from "vuex";

export default {
    name: 'Service',
    components: {
        NavbarService
    },
    computed: {
        ...mapState("utils", ["user", "translator"]),
        ...mapState("service", ["services"]),
        orderedServices() {
            const list = [...this.services];
            const query = String(this.searchQuery || "").trim().toLowerCase();
            const toTime = (value) => {
                if (!value) return 0;

                const [year, month, day] = String(value).split('-').map(Number);
                if (year && month && day) {
                    return new Date(year, month - 1, day).getTime();
                }

                const parsed = Date.parse(String(value));
                return Number.isNaN(parsed) ? 0 : parsed;
            };

            const filteredList = query
                ? list.filter((item) => {
                    const rawDate = String(item.service_date || "");
                    const formattedDate = rawDate.includes('-')
                        ? rawDate.split('-').reverse().join('-')
                        : rawDate;
                    const lodgingName = String(item.lodging_name || "");
                    const serviceHeadline = String(item.service_headline || "");

                    return rawDate.toLowerCase().includes(query)
                        || formattedDate.toLowerCase().includes(query)
                        || lodgingName.toLowerCase().includes(query)
                        || serviceHeadline.toLowerCase().includes(query);
                })
                : list;

            switch (this.selectedOrder) {
                case "date desc":
                    return filteredList.sort((a, b) => toTime(b.service_date) - toTime(a.service_date));
                case "property asc":
                    return filteredList.sort((a, b) => String(a.lodging_name || "").localeCompare(String(b.lodging_name || "")));
                case "property desc":
                    return filteredList.sort((a, b) => String(b.lodging_name || "").localeCompare(String(a.lodging_name || "")));
                case "date asc":
                default:
                    return filteredList.sort((a, b) => toTime(a.service_date) - toTime(b.service_date));
            }
        }
    },
    watch: {
        services() {
            this.isPreLoad = false;
        }
    },
    async created() {
        try {
            this.isPreLoad = true
            await this.$store.dispatch("utils/getUser", { usr: this.$route.query.id });
            await this.$store.dispatch("service/getService", { usr: this.$route.query.id });

        } catch (error) {
            console.error(error);
        }
    },
    data() {
        return {
            isPreLoad: false,
            selectedOrder: "date asc",
            searchQuery: "",
        };
    },
    methods: {},
    filters: {
        transformDate(value) {
            if (!value) return '';
            const backendDate = value.split('-');
            return `${backendDate[2]}-${backendDate[1]}-${backendDate[0]}`;
        },
        toLower(value) {
            if (!value) return "";
            value = value.toString();
            return value.toLowerCase();
        },
    }
}
</script>

<style scoped>
header .flex-titular {
    display: flex;
    justify-content: space-between;
    max-width: 800px;
    margin: auto;
}

th {
    cursor: pointer;
}

.ServiceDetail {
    cursor: pointer;
}

.ServiceDetail:hover {
    box-shadow: 0 .125rem .45rem rgba(0, 0, 0, .2)
}
</style>